import React, { useEffect, useState } from 'react'
import {Row,Col,Nav,Tab,Tabs} from 'react-bootstrap'
import SidebarofTdash from './subComponents/SidebarofTdash';
import { DayPicker } from 'react-day-picker';
import Dropdown from 'react-dropdown';
import {BsChevronDown} from 'react-icons/bs'
import { Link, useNavigate } from 'react-router-dom'
import { attendanceApiteacher, headerpropst, periodsubjectdatateacher, salaryInformationteacher } from '../../../utils/DashboardApi/TeacherDashboardApi';
import { Doughnut } from "react-chartjs-2";
import axios from 'axios';
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import {HiOutlineBell} from 'react-icons/hi'
import { noticeData } from '../../../utils/DashboardApi/StudentDashboardApi';
import HeaderOfTDashComp from './subComponents/HeaderOfTDashComp';
const TeaDashComp = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    const currentMonthName = monthNames[currentMonth - 1];
    const currentYear = currentDate.getFullYear();
    
    const [mycurrentmonth,setmycurrentmonth] = useState("Jan")
    const [mycurrentyear,setmycurrentyear] = useState(currentYear)

    const [selected, setSelected] = React.useState(Date);
    const [monthdrpdwnval,setmonthdrpdwnval]=useState(mycurrentmonth)
    const [yeardrpdwnval,setyeardrpdwnval]=useState(mycurrentyear)
    const headers = {
        "X-localization": localStorage.getItem("lan"),
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Max-Age": 3600,
      };
    const [NoticeId, setNoticeId] = useState("");
    const [NoticeHeader, setNoticeHeader] = useState("");
    const [NoticeBody, setNoticeBody] = useState("");
    const [NoticeDate, setNoticeDate] = useState("");
    const [noticeresponse, setnoticeresponse] = useState([]);
    const dayoptions = [
        'Select Day','Saturday','Sunday','Monday','Tuesday','Wednesday','Thursday','Frriday'
    ];
    const defaultOptiontype = dayoptions[0];
    const [drpday,setDrpday] = useState("")
    function drpfunctionyear(data,myid){
    setyeardrpdwnval(data)
    }
    const navigate = useNavigate()
    useEffect(() => {
    const fetchTeacDashboardNotice = async () => {
        try {
        const myresponse = await axios.get(
            "https://sass.britishstandardschool.com/api/Public/LatestNotice", {},
            headers
        );
        
        setnoticeresponse(myresponse.data);
        } catch (err) {
        if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
        } else {
            console.error(`Error: ${err.message}`);
        }
        }
    };
    fetchTeacDashboardNotice();
    }, []);

    const [AttendanceResponse, setAttendanceResponse] = useState({});
    const chart1color1 = "rgba(245, 141, 145, 1)";
    const chart1color2 = "rgba(127, 228, 169, 1)";
    const chart1color3 = "rgba(177, 206, 255, 1)";

    useEffect(() => {
    const fetchAttChart = async () => {
        if (window.token == null) {
            console.log(window.token)
            navigate("/login");
        }
        else{
            try {
                const response = await axios.get(
                `https://localhost:7229/api/TeacherDashboard/GetEmpAttendancePercentage?EmpId=${headerpropst.id}&month=${monthdrpdwnval}&year=${yeardrpdwnval}`, {
                    headers: {
                        'Authorization': 'bearer ' + window.token
                    },
                }
                );  
                //console.log(response.data.value[0]);
             
                setAttendanceResponse(response.data.value[0]);
                } catch (err) {
                if (err.response) {
                    //navigate("/login");
                    console.error(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
                }
        }
        
    };
   
    if(yeardrpdwnval && monthdrpdwnval){

        fetchAttChart();
    }
    }, [monthdrpdwnval,yeardrpdwnval]);
    const chdata2 = {
        labels: ["present","absent", "late"],
        datasets: [{
            data: [AttendanceResponse.Present, AttendanceResponse.Absent, AttendanceResponse.Late],
            backgroundColor: [
                chart1color2,
                chart1color1,
                chart1color3

            ],
            borderWidth: 0,


        }],

    }
    const dropdownvalue=(e)=>{        
        setDrpday(e.value)
        console.log(drpday)
      }
      function drpfunctionmonth(data,myid){
        setmonthdrpdwnval(data)
    }
    const optionmemonth = [
      {
          opt:'Jan'
      },
      {
          opt:'Feb'
      },
      {
        opt:'Mar'
      },
      {
          opt:'Apr'
      },
      {
          opt:'May'
      },
      {
          opt:'Jun'
      },
      {
        opt:'Jul'
      },
      {
        opt:'Aug'
      },
      {
          opt:'Sep'
      },
      {
          opt:'Oct'
      },
      {
          opt:'Nov'
      },
      {
          opt:'Dec'
      }
    ]
    const optionmeyear = [
    {
        opt:2023
    },
    {
        opt:2022
    }
    ]
    
    const [dashheaderchange,setdashheaderchange] = useState("Good Morning Farhana")
   
    return (
      <>
        <div className="teadashcomp">
          <SidebarofTdash />
          <div className="rightpartcontentwrap">
            <HeaderOfTDashComp
              heading="Good Morning Farhana"
              myprops={headerpropst}
            />

            <div className="tabPane">
              <div className="tabpaneheightadjust dashboardTab">
                <Row className="firstRow">
                  <Col lg={4} style={{ paddingRight: "15px" }}>
                    <div className="samebox sameboxteacher sameboxroutine">
                      <div className="headerpart">
                        <div className="flexwrap">
                          <h4>Class Routine</h4>
                          <div className="dropdownwrapper">
                            <Dropdown
                              className="filterdropone"
                              options={dayoptions}
                              onChange={(e) => dropdownvalue(e)}
                              value={defaultOptiontype}
                            />
                            <BsChevronDown />
                          </div>
                        </div>
                      </div>
                      <div className="routinetable">
                        <table>
                          <thead>
                            <tr>
                              {periodsubjectdatateacher.heading.map(
                                (item, key) => {
                                  return <th>{item.head}</th>;
                                }
                              )}
                            </tr>
                          </thead>
                          {drpday == "Saturday"
                            ? periodsubjectdatateacher.saturday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )
                            : drpday == "Sunday"
                            ? periodsubjectdatateacher.sunday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )
                            : drpday == "Monday"
                            ? periodsubjectdatateacher.monday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )
                            : drpday == "Tuesday"
                            ? periodsubjectdatateacher.tuesday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )
                            : drpday == "Wednesday"
                            ? periodsubjectdatateacher.wednesday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )
                            : drpday == "Thursday"
                            ? periodsubjectdatateacher.thursday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )
                            : drpday == "Friday"
                            ? periodsubjectdatateacher.friday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )
                            : periodsubjectdatateacher.saturday.map(
                                (item, key) => {
                                  return (
                                    <tr>
                                      <td>{item.periodnumber} Period </td>
                                      <td>{item.class}</td>
                                      <td>{item.section}</td>
                                    </tr>
                                  );
                                }
                              )}
                        </table>
                      </div>
                      <div className="extraclassbox">
                        <p>No Extra Class</p>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} style={{ paddingLeft: "0" }}>
                    <div className="samebox sameboxteacher">
                      <div className="headerpart">
                        <div className="flexwrap">
                          <h4>Attendance</h4>
                          <p eventKey="second">View all</p>
                        </div>
                      </div>
                      <div className="drpmonthyearwrapper">
                        <div className="leftone">
                          <Dropdown2
                            myplaceholder={mycurrentmonth}
                            func={drpfunctionmonth}
                            fontsize="12"
                            fontfamily="'Poppins', sans-serif"
                            options={optionmemonth}
                          />
                        </div>
                        <div className="rightone">
                          <Dropdown2
                          myplaceholder={mycurrentyear}
                            func={drpfunctionyear}
                            fontsize="12"
                            fontfamily="'Poppins', sans-serif"
                            options={optionmeyear}
                          />
                        </div>
                      </div>
                      {/* <div className="chartwrapperheight" style={{height:"300px"}}>
                        {
                          // chdata2?
                          <div className="tab-pane">
                            <div className="presenttext">
                              <p>{AttendanceResponse.Present?AttendanceResponse.Present:0}%</p>
                              <p>present</p>
                            </div>
                            <div className="latetext">
                              <p>{AttendanceResponse.Late?AttendanceResponse.Late:0}%</p>
                              <p>late</p>
                            </div>
                            <div className="absenttext">
                              <p>{AttendanceResponse.Absent?AttendanceResponse.Absent:0}%</p>
                              <p>absent</p>
                            </div>
                            <Doughnut
                              style={{
                                margin: "0 auto",
                                width: "250px",
                                height: "250px",
                              }}
                              data={chdata2}
                            />
                          </div>

                          // :
                          // <Doughnut style={{margin:"0 auto",width:"250px",height:"250px"}} data={
                          //     {
                          //         labels:["absent","present","late"],
                          //         datasets:[{
                          //             data:[50,10,40],
                          //             backgroundColor:[
                          //                 chart1color1,
                          //                 chart1color2,
                          //                 chart1color3

                          //             ],
                          //             borderWidth:0,

                          //         }],
                          //         options: {
                          //             plugins: {
                          //                 legend: {
                          //                 display: false
                          //                 }
                          //             }
                          //             }}
                          // }/>
                        }
                      </div> */}
                      <div className="chartwrapperheight" style={{height:"250px"}}>
                                                {

                                                    attendanceApiteacher.map((item, key) => {
                                                        return (
                                                            yeardrpdwnval && monthdrpdwnval ?
                                                                item.month.map((item2, key2) => {
                                                                    if (item.yearnum == yeardrpdwnval && item2.monthname == monthdrpdwnval) {

                                                                        return (
                                                                            <>

                                                                                <Doughnut style={{ margin: "0 auto", width: "250px", height: "250px" }} data={
                                                                                    {
                                                                                        labels: ["absent", "present", "late"],
                                                                                        datasets: [{
                                                                                            data: [item2.data.absent, item2.data.present, item2.data.late],
                                                                                            backgroundColor: [
                                                                                                chart1color1,
                                                                                                chart1color2,
                                                                                                chart1color3

                                                                                            ],
                                                                                            borderWidth: 0,


                                                                                        }],
                                                                                        options: {
                                                                                            plugins: {
                                                                                                legend: {
                                                                                                    display: false
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                } />

                                                                            </>
                                                                        )
                                                                    }
                                                                })
                                                                :
                                                                <Doughnut style={{ margin: "0 auto", width: "250px", height: "250px" }} data={
                                                                    {
                                                                        labels: ["absent", "present", "late"],
                                                                        datasets: [{
                                                                            data: [50, 10, 40],
                                                                            backgroundColor: [
                                                                                chart1color1,
                                                                                chart1color2,
                                                                                chart1color3

                                                                            ],
                                                                            borderWidth: 0,


                                                                        }],
                                                                        options: {
                                                                            plugins: {
                                                                                legend: {
                                                                                    display: false
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                } />

                                                        )


                                                    })

                                                }
                                            </div>
                    </div>
                  </Col>
                  <Col
                    lg={4}
                    style={{ paddingLeft: "0", paddingRight: "15px" }}
                  >
                    <div className="samebox sameboxteacher semesterprogress">
                      <div className="headerpart">
                        <div className="flexwrap">
                          <h4>Semester Progress</h4>
                          <p>View all</p>
                        </div>
                      </div>
                      <div className="progressboxmini">
                        <div className="progressminileft">
                          <CircularProgressbar
                            value={91}
                            text={`91%`}
                            strokeWidth={10}
                            styles={buildStyles({
                              textColor: "#ED1C24",
                              pathColor: "#ED1C24",
                              trailColor: "white",
                            })}
                          />
                        </div>
                        <div className="progressminiright">
                          <p>Lesson progress</p>
                          <h4>
                            <span style={{ color: "#000" }}>30</span> / 33
                          </h4>
                        </div>
                      </div>
                      <div className="progressboxmini">
                        <div className="progressminileft">
                          <img
                            src="./assets/images/dashboards/teacherDashboard/progress/calendar.png"
                            alt="calendar.png"
                          />
                        </div>
                        <div className="progressminiright">
                          <p>Semester Exam in</p>
                          <h4>
                            <span style={{ color: "#000" }}>7 Days</span>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="secondRow">
                  <Col lg={4} style={{ paddingRight: "15px" }}>
                    <div className="samebox sameboxteacher prevhistory">
                      <div className="headerpart">
                        <div className="flexwrap">
                          <h4>Salary Information</h4>
                          <p>View all</p>
                        </div>
                      </div>

                      <div className="smallheading">
                        <h5>
                          <span style={{ fontWeight: "500" }}>
                            Current Status:
                          </span>{" "}
                          {salaryInformationteacher.currentstatus}
                        </h5>
                      </div>
                      <div className="cardbarprevphistory cardbarprevphistoryteacher">
                        <div className="paymenthistoryoverview">
                          <div className="paymenthistoryovflexwrap">
                            {salaryInformationteacher.salaryinfodetails.map(
                              (item, key) => {
                                return (
                                  <div className="payhpartcardbar">
                                    <div className="monthdatewrapper">
                                      <h3>{item.month}</h3>
                                      <p>Date: {item.date}</p>
                                    </div>
                                    <div className="rightsidflexpart">
                                      <div className="pillright">
                                        <h6>Paid</h6>
                                      </div>
                                      <div className="amount">
                                        <p>৳ {item.amount}</p>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col
                    lg={4}
                    style={{ paddingLeft: "0", paddingRight: "15px" }}
                  >
                    <div className="samebox sameboxteacher">
                      <div className="headerpart" style={{ marginBottom: "0" }}>
                        <div className="flexwrap">
                          <div className="flexwrap2">
                            <h4>Notice </h4>
                          </div>
                          <p>View more</p>
                        </div>
                      </div>
                      <div className="contentpart">
                        {noticeresponse.map((item, key) => {
                          return (
                            <div className="noticebarmini" key={key}>
                              <div className="publishdatepart teacherpublishpart">
                                <p>{item.noticeDate.split(",")[0]}</p>
                                <p>{item.noticeDate.split(",")[1]}</p>
                              </div>
                              <div className="noticeboxtextbox">
                                <h5 style={{ paddingLeft: "30" }}>
                                  {" "}
                                  {item.header}
                                </h5>
                                <p style={{ paddingLeft: "50" }}>
                                  {item.body.substr(0, 38)}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Col>
                  <Col
                    lg={4}
                    style={{ paddingLeft: "0", paddingRight: "15px" }}
                  >
                    <div className="samebox sameboxteacher sameboxteacher sameboxcalender">
                      <DayPicker
                        mode="single"
                        selected={selected}
                        onSelect={setSelected}
                        showOutsideDays
                      />

                      <div className="eventbox">
                        <p>No Event</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}

export default TeaDashComp